import { useIsMutating, useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { UserAction } from 'interfaces/MeshMaven';
import { useDispatch } from 'react-redux';
import { useIsMutationCancelled } from 'utils/helpers/reactQueryHelpers';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { setSelectedRevision, useSelectedRevision } from '../slice/meshMavenSlice';
import { CustomerFeedbackAPIResponse, CustomerFeedbackRequestBody } from '../types/CustomerFeedback';

const customerFeedback = ({
  userAction,
  requestId,
  recommendedContent,
  usedContent,
}: CustomerFeedbackRequestBody): Promise<CustomerFeedbackAPIResponse> =>
  sendRequest({
    url: endpoints.performanceReview.textAnalysis.customerFeedback,
    method: 'POST',
    credentials: 'include',
    body: {
      userAction,
      requestId,
      recommendedContent,
      usedContent,
      serviceName: 'review_rephrase',
    },
    queryParams: {},
  });

export const useCustomerFeedbackMutation = () => {
  const dispatch = useDispatch();

  const selectedRevision = useSelectedRevision();

  const isMutationCancelled = useIsMutationCancelled();

  return useMutation<any, { message?: string }, { userAction: UserAction }>(
    ({ userAction }) =>
      customerFeedback({
        userAction,
        requestId: selectedRevision.requestId,
        recommendedContent: {
          comment: selectedRevision.originalState,
        },
        usedContent: {
          comment: selectedRevision.updatedState,
        },
      }),
    {
      mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.customerFeedback],
      onSuccess: (_, { userAction }) => {
        if (isMutationCancelled([REACT_QUERY_KEYS.reviewsGenAi.customerFeedback])) {
          return;
        }
        if (userAction !== 'USE') {
          dispatch(
            setSelectedRevision({
              revision: { ...selectedRevision, isAIFeedbackProvided: true },
            })
          );
        }
      },
    }
  );
};

export const useCustomerFeedbackLoading = () =>
  useIsMutating({
    mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.customerFeedback],
  }) > 0;
